export default function MaintenancePage() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6">
      <div className="max-w-2xl text-center">
        <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-yellow-100 mb-8">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-12 h-12 text-yellow-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.963a1 1 0 00.95.69h4.167c.969 0 1.371 1.24.588 1.81l-3.372 2.45a1 1 0 00-.364 1.118l1.287 3.963c.3.921-.755 1.688-1.539 1.118l-3.372-2.45a1 1 0 00-1.176 0l-3.372 2.45c-.784.57-1.838-.197-1.539-1.118l1.287-3.963a1 1 0 00-.364-1.118L2.46 9.39c-.783-.57-.38-1.81.588-1.81h4.167a1 1 0 00.95-.69l1.286-3.963z"
            />
          </svg>
        </div>

        <h1 className="text-5xl font-bold text-gray-900 mb-4">
          Estamos en mantenimiento
        </h1>

        <p className="text-lg text-gray-600 mb-8">
          Nuestro sitio web está recibiendo mejoras para ofrecer una mejor
          experiencia. Volveremos a estar disponibles lo antes posible.
        </p>

        <div className="bg-yellow-50 border border-yellow-200 rounded-2xl p-6 mb-8">
          <p className="text-yellow-800 font-medium">
            Gracias por tu paciencia y comprensión.
          </p>
        </div>

        <div className="flex justify-center">
          <div className="h-2 w-32 bg-yellow-400 rounded-full animate-pulse" />
        </div>

        <p className="mt-8 text-sm text-gray-500">
          Si necesitas ayuda urgente, ponte en contacto con nuestro equipo de
          soporte.
        </p>
      </div>
    </div>
  );
}